// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".router-link-exact-active {\n  color: #73bbd3;\n  border-color: #8ce2ff;\n}\n", ""]);
// Exports
module.exports = exports;
